module.exports = __webpack_public_path__ + "assets/img/picture3.0648812e.svg";